import { __ } from '~/locale';
import WikiDiscussionSorter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_discussion_sorter.vue?vue3';
export default {
    name: 'WikiNotesActivityHeader',
    components: {
        WikiDiscussionSorter
    },
    i18n: {
        headerText: __('Comments')
    }
};
